import { Moment } from 'moment';

export interface ITenant {
  id?: number;
  name?: string;
  website?: string;
  createdDate?: Moment;
  lastModifiedDate?: Moment;
  zoneId?: string;
  status?: number;
  keepalive?: number;
}

export const defaultValue: Readonly<ITenant> = {};
